import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const data_migration_screen = lazy(() => import("./DataMigrationParent"));

const DATA_MIGRATION_ROUTES: RouteObject[] = [
  {
    path: "/private/data-migration",
    element: React.createElement(data_migration_screen),
  },
];

export default DATA_MIGRATION_ROUTES;
